export default {
  computed: {
    scopeIsEvo() {
      return this.$helpers.getValue(this.$configs, `app.isEvo`)
    },
    scopeIsIbs() {
      return this.$helpers.getValue(this.$configs, `app.isIbs`)
    },
    isOnePlan() {
      return this.$helpers.getValue(this.$configs, `app.isOnePlan`)
    },
  },
  methods: {
    /**
     * @param field must be null if type is array
     * @param path pass config path
     * @param type accept boolean|array
     * */
    scopeHideFields(field, path, type = 'boolean') {
      let fields = this.$helpers.getValue(this.$configs, `app.${path}`).hide || []
      if (type === 'boolean') {
        return !fields.includes(field)
      } else if (type === 'array') {
        return fields
      } else {
        return []
      }
    },
    /**
     * @param field must be null if type is array
     * @param path pass config path
     * @param type accept boolean|array
     * */
    scopeShowFields(field, path, type = 'boolean') {
      let fields = this.$helpers.getValue(this.$configs, `app.${path}`).show || []
      if (type === 'boolean') {
        return fields.includes(field)
      } else if (type === 'array') {
        return fields
      } else {
        return []
      }
    },
    scopeGetFields(path) {
      return this.$helpers.getValue(this.$configs, `app.${path}`).get || []
    },
    scopeTranslateField(field, path) {
      let fields = this.$helpers.getValue(this.$configs, `app.${path}`).fields || []
      let match = fields.find(x => x.name === field)
      if (match) {
        return this.$t(`${match.translationKey}`)
      }
      return this.$t('common.words.notAvailableShort')
    },
    scopeTranslateWord(field, path) {
      let fields = this.$helpers.getValue(this.$configs, `app.${path}`).words || []
      let match = fields.find(x => x.name === field)
      if (match) {
        return this.$t(`${match.translationKey}`)
      }
      return this.$t('common.words.notAvailableShort')
    },
    scopeTableColumns(column, path) {
      let columns = this.$helpers.getValue(this.$configs, `app.${path}`).columns || []
      return columns.findIndex(x => x.name === column) !== -1
    },
    scopeHideTableColumn(column, path) {
      let columns = this.$helpers.getValue(this.$configs, `app.${path}`).columns.hide || []
      return columns.findIndex(x => x === column) === -1
    },
    scopeFieldReadOnly(field, path) {
      let columns = this.$helpers.getValue(this.$configs, `app.${path}`).readOnly || []
      return columns.includes(field)
    },
    scopeGetTableColumns(path) {
      return this.$helpers.getValue(this.$configs, `app.${path}`).get || []
    },
    scopeEnableFeature(feature, path) {
      return this.$helpers.getValue(this.$configs, `app.${path}.${feature}`, false)
    },
    scopeShowElements(name, path) {
      return this.$helpers.getValue(this.$configs, `app.${path}.${name}`, false)
    },
    scopeHideElements(name, path) {
      return this.$helpers.getValue(this.$configs, `app.${path}.${name}`, false)
    },
    scopeAddProps(path) {
      return this.$helpers.getValue(this.$configs, `app.${path}`, [])
    },
    scopeAddClasses(path) {
      return this.$helpers.getValue(this.$configs, `app.${path}`, [])
    },
  },
}
